import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('stripeSubscriptionCard');

    return {
        NOT_SET: t('notSet'),
        RENEWALDATE: t('renewalDate'),
        SEATS: t('seats'),
        SUBSCRIPTION: t('subscription'),
        SUMMARY: t('summary'),
        TOTAL_SEATS: (seats?: number) => t('totalSeats', { seats })
    };
};

export default useTranslation;
